import { render, staticRenderFns } from "./RegAuth.vue?vue&type=template&id=5465232a&"
import script from "./RegAuth.vue?vue&type=script&lang=js&"
export * from "./RegAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports